const voiceMapping: { [key: string]: string } = {
    "Jake": "en-US-Journey-D",
    "Tiffany": "en-US-Journey-F",
    "Ellen": "en-US-Journey-O",
    "Katherine": "en-US-Neural2-C",
    "Michael": "en-US-Neural2-D",
    "Emily": "en-US-Neural2-F",
    "Kylie": "en-US-Neural2-H",
    "Alex": "en-US-Neural2-I",
    "Anne": "en-US-News-L",
    "Jonesy": "en-US-Standard-D"
};

export default voiceMapping;